var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateExists)?_c('v-btn',{staticClass:"shiny",attrs:{"color":"error","rel":"nofollow"},on:{"mouseenter":function($event){_vm.text = 'LOAD UPDATE'},"mouseleave":function($event){_vm.text = 'Update Available'},"click":_vm.refreshApp}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }